/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { useContext, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
    object, func, string, bool, shape, number,
} from 'prop-types';
import mbpLogger from '@module-logger/mbp';

import CardMedia from '@material-ui/core/CardMedia';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import Close from '@material-ui/icons/Close';
import { bindActionCreators } from 'redux';

import { useHistory } from 'react-router';
import { getSSRDeviceType, getWineData } from '../../../../state/ducks/App/App-Selectors';
import { pmallPluginConfig, getPmallURL } from '../../../../state/ducks/Common/ducks/PmallPersonalization/PmallPersonalization-Helper';
import * as tagManagerActions from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { removePmallItem, setPmallPersonalizationData, updateCartPmallPersonalization } from '../../../../state/ducks/Common/ducks/PmallPersonalization/PmallPersonalization-Actions';
import { getPmallSummaryInfo } from '../../../../state/ducks/Common/Common-Selectors';
import { CrossMerch } from '../../../components/GraphqlComponents/CrossMerchContainer/CrossMerchContainer';
import { addToCartNewCartServices } from '../../../../state/ducks/AddToCart/AddToCart-Actions';
import { getShopTheSite } from '../../../pages/Account/utils/shopTheSite';
import { getContactId } from '../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import AddToCartBuilderObject from '../../../components/GraphqlComponents/GraphqlProductPage/Partials/GraphqlFoodAddToCart/Partials/AddToCartBuilderObject';
import { getAttributeByName, getProductDemandType } from '../../page/pageHelpers';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme) => ({

    dialogPaper: {
        margin: 'unset', // default margin too big for mobile so remove
        maxWidth: '1200px',
        width: '100%',
        [theme.breakpoints.down('md')]: {
            maxWidth: 'calc(100% - 15px)',
        },
    },

    cardMediaRoot: {
        height: '90vh',
        width: '100%',
        border: 'none',
        maxHeight: '80vh',

    },

    closeButtonRoot: {
        '&:hover, &:focus, &:active': {
            cursor: 'pointer',
        },
    },
});

const PmallPersonalization = (props) => {
    const {
        classes,
        pmallSummaryInfo,
        product,
        sku,
        pageType,
        isOpen,
        handleModalPmall,
        trackEvent,
        callRemovePmallItem,
        callSetPmallData,
        cartItemId,
        callUpdateCartPmallPersonalization,
        ssrDeviceType,
        refnumCheckout,

        actionAddToCart,
        contactId,
        isPassportBundleProduct,
        location,
        selectedSku,
        quantity,
        deliveryIndicatorPDP,
        deliveryMethod,
        handleMiniCartModalClick,
        wineValidation,
    } = props;
    const hasWine = selectedSku?.ageVerifyFlag;
    const { featureFlags = {} } = useContext(CrossMerch);
    const wineVerify = {
        hasWine,
        wineValidation,
    };
    const isPmallPersonalizationAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'is_pmall_personalization_enabled');
    const isPmallPersonalizationEnabled = isPmallPersonalizationAttr?.values?.[0]?.value === 'true';

    const isPmallPersonalizationTypeAttr = (selectedSku?.attributes || [])?.find((attr) => attr.name === 'personalization_type_enabled');
    const pmallPersonalizationType = !!isPmallPersonalizationTypeAttr?.values?.[0]?.value;

    if (!featureFlags['is-pmall-enabled'] || (pageType === 'pdp' && product?.brandId !== '1030' && product?.brandId !== '1033' && !isPmallPersonalizationEnabled && !pmallPersonalizationType)) {
        return null;
    }
    // Adding this feature for brand specific for eg. enabling new pmall ATC for HD only
    const ffCurrentBrandPmallAtcOnSave = useSelector(getFeatureFlag('is-pmall-product-save-atc-enabled'));
    const isNotMobile = ssrDeviceType !== 'mobile'; // need only for tab and desktop

    const history = useHistory();

    /**
     *
     * @param {*} pmallInfo -> Response of pmall model
     * @returns Add to cart after success of Pmall model, and it will only trigger if is-pmall-product-save-atc-enabled is enabled
     *
     */
    const handleAddToCart = (pmallInfo) => {
        const productDemandType = getProductDemandType(location);
        const categoryId = location.state?.categoryId || '';
        const categoryPath = location.state?.categoryPath || '';
        const categoryName = location.state?.categoryName || '';

        const isPersonalizable = product?.isPersonalizable;
        const productType = product?.productType;
        const brandId = product?.brandId;
        const partNumber = product?.partNumber;

        const isTryMeProduct = !!getAttributeByName(product.attributes, 'try_me').length > 0;
        const subscriptionData = {};

        const attributes = {
            categoryId,
            categoryPath,
            categoryIdent: categoryName,
            demandTypeCode: productDemandType,
            tryMe: isTryMeProduct,
        };

        const personalization = {
            isPersonalizable,
            personalizationData: null,
            personalizedData: null,
        };

        // GiftList - get Shop The Site content
        const giftList = getShopTheSite(contactId) || {};

        const productLineItemType = productType;
        const ATC = new AddToCartBuilderObject(
            brandId,
            sku,
            quantity,
            [], // CYO Component
            [], // Addons
            productLineItemType,
            subscriptionData,
            attributes,
            wineVerify, // wine object
            personalization,
            { customizations: pmallInfo },
            giftList,
            deliveryIndicatorPDP,
            deliveryMethod,
            contactId,
            selectedSku,
        );

        let passportBundle = {};
        if (isPassportBundleProduct?.enable) {
            passportBundle = {
                enable: true,
                passportSku: isPassportBundleProduct?.passportSku,
            };
        }

        const mainProduct = ATC.getPayload();
        // The new cart services dont support the product code with brand code attached,
        // it need be removed.
        if (mainProduct?.productCode) {
            mainProduct.productCode = mainProduct.productCode?.replace('1030-', '');
        }

        const reqObj = [mainProduct];
        const addonsAsProduct = []; // Doing a second call add to cart but as add-on
        if (pmallInfo?.addons?.length > 0) {
            pmallInfo?.addons.forEach((addon) => {
                const prodSku = addon.productSku?.replace('1030-', '');
                addonsAsProduct.push({
                    attributes: mainProduct.attributes || [],
                    brandCode: product?.brandId || '1030',
                    productCode: prodSku,
                    quantity: addon.qty,
                    personalization: {
                        personalizationId: addon.refnum,
                        personalizationType: 'EXTERNAL',
                    },
                });
            });
        }

        actionAddToCart({
            item: reqObj,
            history,
            categoryId,
            partNumber,
            categoryPath,
            categoryName,
            enableMinicart: featureFlags['is-mini-cart-enabled'] && isNotMobile,
            handleMiniCartModalClick,
            isMobile: false,
            passportBundle,
            addonsAsProduct,
        });
        return true;
    };

    const refnum = pmallSummaryInfo?.customizations?.refnum || refnumCheckout;
    const brand = product?.brandId;
    const url = getPmallURL({ sku, refnum, brand });

    /**
     * Wrap this in catch as its 3rd party and maybe
     * iframe stops sending data or errors out iteself?
     */
    const pmallListener = (event) => {
        const { sdkURL } = pmallPluginConfig;
        if (event.origin !== `https://${sdkURL}`) return;

        let parsedData;
        try {
            parsedData = JSON.parse(event.data);
            if (parsedData?.action === 'savemodal' && parsedData.postdata) {
                callSetPmallData(parsedData.postdata);
                if (pageType === 'pdp') {
                    if (parsedData?.postdata?.status === 'success' && ffCurrentBrandPmallAtcOnSave && !refnum) {
                        handleAddToCart(parsedData.postdata);
                    }
                    handleModalPmall(false);
                    if (window.addEventListener) {
                        window.removeEventListener('message', pmallListener, false);
                    } else if (window.detachEvent) {
                        window.detachEvent('onmessage', pmallListener);
                    }
                } else if (pageType) {
                    const pmallData = {
                        cartItemId,
                        refnum: parsedData.postdata.refnum,
                        description: parsedData.postdata.description,
                        previewUrl: parsedData.postdata.imageURL,
                        onCloseModal: handleModalPmall,
                    };

                    if (parsedData.postdata?.addonCount > 0) {
                        pmallData.addonCount = parsedData.postdata.addonCount;
                    }

                    callUpdateCartPmallPersonalization(pmallData);

                    if (window.addEventListener) {
                        window.removeEventListener('message', pmallListener, false);
                    } else if (window.detachEvent) {
                        window.detachEvent('onmessage', pmallListener);
                    }
                }
            }
        } catch (error) {
            mbpLogger.logError({
                appName: process.env.npm_package_name,
                component: 'PmallDialog.js',
                message: 'Error parsing Pmall iFrame data',
                error,
            });
            parsedData = { postdata: { refnum: '' } };
            callRemovePmallItem();
            handleModalPmall(false);
        }
    };

    useEffect(() => {
        if (!isOpen) {
            if (window.addEventListener) {
                window.removeEventListener('message', pmallListener, false);
            } else if (window.detachEvent) {
                window.detachEvent('onmessage', pmallListener);
            }
        } else if (typeof window !== 'undefined') {
            if (window.addEventListener) {
                window.addEventListener('message', pmallListener, false);
            } else {
                window.attachEvent('onmessage', pmallListener);
            }
        }
        return () => {
            window.removeEventListener('message', pmallListener);
            if (window.detachEvent) {
                window.detachEvent('onmessage', pmallListener);
            } else {
                window.removeEventListener('onmessage', pmallListener);
            }
        };
    }, [isOpen]);

    /**
     * Setting maxWidth to false applied this style:
     *      max-width: calc(100% - 64px)
     * which is breaking mobile. Conditionally pass it using a variable
     * depending on SSR typpe.
     */

    return (
        <Dialog
            open={isOpen}
            disableBackdropClick // disable close outside for only clean the edit changes is the user close using the X button
            scroll="paper"
            onEntered={() => {
                trackEvent({
                    eventCategory: (pageType === 'pdp') ? 'Product Page' : 'Checkout',
                    eventAction: 'PersonalizationMall Modal',
                    eventLabel: !refnum ? 'Open' : 'Edit',
                });
            }}
            classes={{
                paper: classes.dialogPaper,
            }}
        >
            <DialogActions>
                <Close
                    data-testid="close-pmall-dialog-button"
                    className={classes.closeButtonRoot}
                    onClick={() => { handleModalPmall(false); }}
                />
            </DialogActions>

            <CardMedia
                className={classes.cardMediaRoot}
                component="iframe"
                src={url}
            />

        </Dialog>
    );
};

PmallPersonalization.propTypes = {
    ssrDeviceType: string.isRequired,
    pmallSummaryInfo: object.isRequired,
    product: object,
    isOpen: bool.isRequired,
    sku: string.isRequired,
    classes: object.isRequired,
    pageType: string,
    trackEvent: func.isRequired,
    callRemovePmallItem: func.isRequired,
    callSetPmallData: func.isRequired,
    handleModalPmall: func.isRequired,
    cartItemId: string,
    callUpdateCartPmallPersonalization: func.isRequired,
    refnumCheckout: string,
    actionAddToCart: func,
    contactId: string,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    location: shape({
        state: shape({
            categoryId: string,
            categoryPath: string,
            categoryName: string,
        }),
    }),
    selectedSku: shape({
        id: string,
    }),
    quantity: number,
    deliveryIndicatorPDP: string,
    deliveryMethod: string,
    handleMiniCartModalClick: func,
    wineValidation: shape({
        wineAvailability: object, // object type array
        wineVerify: shape({
            birthDay: 'string',
            birthMonth: 'string',
            birthYear: 'string',
            minAge: 'string',
        }),
    }),
};

PmallPersonalization.defaultProps = {
    product: {},
    pageType: 'pdp', // pdp or checkout
    cartItemId: null,
    refnumCheckout: null,
    actionAddToCart: () => { },
    contactId: '',
    isPassportBundleProduct: {},
    location: {},
    selectedSku: {},
    quantity: 1,
    deliveryIndicatorPDP: '',
    deliveryMethod: '',
    handleMiniCartModalClick: () => { },
    wineValidation: null,
};

const mapStateToProps = (state) => ({   // eslint-disable-line arrow-parens
    ssrDeviceType: getSSRDeviceType(state),
    pmallSummaryInfo: getPmallSummaryInfo(state),
    contactId: getContactId(state),
    wineValidation: getWineData(state),
});

const mapDispatcherToProps = (dispatch) => bindActionCreators({
    callRemovePmallItem: removePmallItem,
    callSetPmallData: setPmallPersonalizationData,
    callUpdateCartPmallPersonalization: updateCartPmallPersonalization,
    trackEvent: tagManagerActions.trackEvent,
    actionAddToCart: addToCartNewCartServices,
}, dispatch);

export default connect(mapStateToProps, mapDispatcherToProps)(withStyles(styles)(PmallPersonalization));
